module.exports = __webpack_public_path__ + "static/media/nuvemshop-manual-import2.d8e5ff5b.png";